export default __webpack_public_path__ + "static/media/9_1_hl.5efbb8bc.png";